
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

export const HospitalizationSection = () => {
  const { t } = useTranslate();
  const { control } = useFormContext();

  const sections = [
    { name: "hospitalization.reason", label: "child-patient-assessment.reason-for-hospitalization", desc: "hospitalization.reasonDescription" },
    { name: "hospitalization.family", label: "child-patient-assessment.family", desc: "hospitalization.familyDescription" },
    { name: "hospitalization.bloodTransfusion", label: "child-patient-assessment.previous-blood-transfusion", desc: "hospitalization.bloodTransfusionDescription" },
  ];

  return (
    <Box
      sx={{
        border: "1px solid #DBDBDB",
        borderRadius: "4px",
        padding: "20px",
        width: "100%",
      }}
    >
      <Grid
        sx={{
          backgroundColor: "#63B4FF33",
          color: "#2979C3",
          borderRadius: "10px",
        }}
      >
        <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
          {t("adult-patient-assessment.medical-allergy-surgical-family-history")}
        </ByzMuiTypography>
      </Grid>

      <Grid container spacing={2} pt={2}>
        {sections.map((sec) => (
          <Grid key={sec.name} md={2} xs={6}>
            <ByzTitleAndInputBox marginLeft="0px" title={t(sec.label)}>
              <Controller
                name={sec.name}
                control={control}
                render={({ field }) => (
                  <ByzMuiSelect
                    {...field}
                    options={[]}
                    label={t("open-process-menu.select", "capitalize")}
                    sx={{ pt: 1 }}
                  />
                )}
              />
              <ByzTitleAndInputBox
                marginLeft="0px"
                sx={{ marginTop: "8px" }}
                title={t("description", "capitalize")}
              >
                <Controller
                  name={sec.desc}
                  control={control}
                  render={({ field }) => (
                    <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
                  )}
                />
              </ByzTitleAndInputBox>
            </ByzTitleAndInputBox>
          </Grid>
        ))}

        <Grid md={3} xs={6}>
          <ByzTitleAndInputBox marginLeft="0px" title={t("child-patient-assessment.transfusion-reaction")}>
            <Controller
              name="hospitalization.transfusionReaction"
              control={control}
              render={({ field }) => (
                <ByzMuiSelect
                  {...field}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  sx={{ pt: 1 }}
                />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>
    </Box>
  );
};
